import { render } from "./DesktopToolbarSidebar.vue?vue&type=template&id=42c305fb&scoped=true"
import script from "./DesktopToolbarSidebar.vue?vue&type=script&lang=js"
export * from "./DesktopToolbarSidebar.vue?vue&type=script&lang=js"

import "./DesktopToolbarSidebar.vue?vue&type=style&index=0&id=42c305fb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c305fb"]])

export default __exports__